"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const EVENT = {
  ADD_PRODUCT: 'cart',
  CUSTOMER_INFO: 'customer-info',
  MARKETING_INFO: 'marketing-info',
  PERSONAL_INFO: 'personal-info',
  PURCHASE: 'purchase',
  VIEW_PRODUCT: 'view-product'
};
const handlers = {
  [EVENT.VIEW_PRODUCT]: _ref => {
    let {
      price,
      product
    } = _ref;
    return {
      currency: 'AUD',
      products: [{
        product: {
          category: product.type,
          name: product.name,
          price: parseInt(price, 10),
          sku: product.id
        }
      }],
      type: 'prodView'
    };
  },
  [EVENT.ADD_PRODUCT]: _ref2 => {
    let {
      price,
      product
    } = _ref2;
    return {
      currency: 'AUD',
      numItems: 1,
      products: [{
        product: {
          category: product.type,
          name: product.name,
          price: parseInt(price, 10),
          sku: product.id
        },
        quantity: 1
      }],
      total: parseInt(price, 10),
      type: 'cart'
    };
  },
  [EVENT.PURCHASE]: _ref3 => {
    let {
      price,
      product
    } = _ref3;
    return {
      cart: {
        products: [{
          product: {
            category: product.type,
            name: product.name,
            price: parseInt(price, 10),
            sku: product.id
          },
          quantity: 1
        }]
      },
      currency: 'AUD',
      orderId: `${product.id}:${Date.now()}`,
      total: parseInt(price, 10),
      type: 'purchase'
    };
  },
  [EVENT.CUSTOMER_INFO]: _ref4 => {
    let {
      membershipId,
      securityCode,
      isLoggedIn
    } = _ref4;
    return {
      info: _lodash.default.omitBy({
        customerId: _lodash.default.isNull(membershipId) ? '' : membershipId,
        imei: _lodash.default.isNull(securityCode) ? '' : securityCode,
        loginStatus: _lodash.default.isBoolean(isLoggedIn) ? Number(isLoggedIn) : undefined
      }, _lodash.default.isUndefined),
      type: 'ctmrinfo'
    };
  },
  [EVENT.PERSONAL_INFO]: _ref5 => {
    let {
      firstName
    } = _ref5;
    return {
      info: _lodash.default.omitBy({
        firstname: _lodash.default.isNull(firstName) ? '' : firstName
      }, _lodash.default.isUndefined),
      type: 'personal'
    };
  },
  [EVENT.MARKETING_INFO]: _ref6 => {
    let {
      targetChannel
    } = _ref6;
    return {
      info: {
        campaignId: targetChannel
      },
      type: 'mrktInfo'
    };
  }
};
const publish = function (type, params) {
  let windowObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;
  const handler = handlers[type];
  if (!handler) {
    return;
  }
  _lodash.default.invoke(windowObj, 'lpTag.sdes.push', handler(params));
};
var _default = {
  EVENT,
  publish
};
exports.default = _default;